import React, { useEffect, useState } from 'react';

const ListOfSchools = ({ value, onChange }) => {
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    // Fetch school list from your API if you have it
    setSchools([
      { id: '', name: 'Select School (Optional)' },
      { id: '2e9d3cda-9b1a-45a2-8b14-7c8129ef2aa9', name: 'Green Valley School' },
      { id: '3f2d4bca-7ab2-4fbc-b0ea-f5df3a03b9b0', name: 'Sunrise Academy' },
    ]);
  }, []);

  return (
    <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="p-2 border rounded w-full"
  >
    <option value="">Select School (Optional)</option>
    {schools.map((school) => (
      <option key={school.id} value={school.id}>
        {school.name}
      </option>
    ))}
  </select>
  );
};

export default ListOfSchools;
